import React from "react";

const TeamMembersContext = React.createContext();

export default TeamMembersContext;
